import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
// all icons
import { RiFridgeLine } from "react-icons/ri";
import { FaWater } from "react-icons/fa";
import { TbAirConditioning } from "react-icons/tb";
import { CiWifiOn } from "react-icons/ci";
import { MdOutlineFreeBreakfast } from "react-icons/md";
import { PiTelevisionSimpleThin } from "react-icons/pi";
import { PiBuildingApartmentLight } from "react-icons/pi";
import { LuBedDouble } from "react-icons/lu";
import { LuBedSingle } from "react-icons/lu";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { LiaRupeeSignSolid } from "react-icons/lia";

import React, { useState, useEffect, useTransition } from "react";
import Contact from "./ContactPage";
import Heading from "../components/common/Heading";
import SampleRoom from "../components/home/SampleRoom";

// import { Helmet } from "react-helmet";

export const RoomBooking = () => {
  const iconMapping = {
    LiaRupeeSignSolid,
    RiFridgeLine,
    FaWater,
    TbAirConditioning,
    CiWifiOn,
    MdOutlineFreeBreakfast,
    PiTelevisionSimpleThin,
    PiBuildingApartmentLight,
    FaIndianRupeeSign,
    LuBedDouble,
    LuBedSingle,
  };

  const location = useLocation(); // Use the useLocation hook
  const isBookingForm = location.pathname.includes("/booking");
  var currentDate = moment().format("llll");
  // console.log("date", currentDate);
  const [startIndex, setStartIndex] = useState(0);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [roomName, setRoomName] = useState([]);
  const [isPending, startTransition] = useTransition();
  const [error, setError] = useState(null);
  const [sessionData, setSessionData] = useState("");

  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [differenceInDays, setDifferenceInDays] = useState(0);
  const navigate = useNavigate();
  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];

  // Function to calculate the difference in days
  const calculateDateDifference = (checkIn, checkOut) => {
    if (checkIn && checkOut) {
      const checkInDateObj = new Date(checkIn);
      const checkOutDateObj = new Date(checkOut);

      // Difference in milliseconds
      const differenceInMs = checkOutDateObj - checkInDateObj;

      // Convert milliseconds to days
      const daysDifference = differenceInMs / (1000 * 60 * 60 * 24);

      setDifferenceInDays(daysDifference);
    }
  };

  const sendInquiry = async (e) => {
    e.preventDefault();

    const form = e.target;
    const requiredFields = [
      "roomType",
      "price",
      "consumerName",
      "phoneNumber",
      "checkIn",
      "checkOut",
    ];

    for (let field of requiredFields) {
      if (!form[field].value) {
        alert(`${field} is required.`);
        return;
      }
    }

    const inquiryData = {
      inquiryDate: currentDate,
      roomType: form.roomType.value,
      price: form.price.value,
      consumerName: form.consumerName.value,
      phoneNumber: form.phoneNumber.value,
      alterNumber: form.alterNumber.value,
      email: form.email.value,
      checkIn: form.checkIn.value,
      checkOut: form.checkOut.value,
      state: form.state.value,
      city: form.city.value,
      address: form.address.value,
    };

    startTransition(async () => {
      const response = await fetch("https://api.bgmhotel.com/roomBookInquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(inquiryData),
      });
      if (response.ok) {
        const result = await response.json();
        console.log("Server Response:", result);
      } else {
        const errorResponse = await response.json();
        alert("Failed to submit inquiry. " + errorResponse.message);
      }
      if (error) {
        setError(error);
        return;
      }
      navigate("/");
    });
  };

  const hasAccents = (text) => /[\u0300-\u036f\u00C0-\u00FF]/.test(text);
  // get all states
  useEffect(() => {
    fetch("https://countriesnow.space/api/v0.1/countries/states", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country: "India" }),
    })
      .then((response) => response.json())
      .then((json) => {
        const stateData = json.data.states.map((state) => state.name);
        setStates(stateData);
      })
      .catch((error) => {
        console.error("Error fetching states:", error);
      });
  }, []);

  // get all cities based on state
  useEffect(() => {
    if (!selectedState) return;
    fetch("https://countriesnow.space/api/v0.1/countries/state/cities", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country: "India", state: selectedState }),
    })
      .then((response) => response.json())
      .then((json) => {
        const filteredCities = json.data.filter((city) => !hasAccents(city));
        setCities(filteredCities);
      })
      .catch((error) => {
        console.error("Error fetching cities:", error);
      });
  }, [selectedState]);

  //  state change function
  const handleStateChange = (event) => {
    setSelectedState(event.target.value);
    setCities([]);
  };

  // render data by  id
  const [roomData, setRoomData] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      fetch(
        // `https://api.bgmhotel.com/rooms/${id}`,
        `https://api.bgmhotel.com/rooms/${id}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
          // console.log("json====>", json);
        })
        .then((json) => {
          setRoomData(json);
          console.log("setRoomData====>", json);
          setMainImage(json.mainImage); // Set the initial main image

          // setMainImage(json.thumbnail); // Set the initial main image
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } else return;
  }, []);

  useEffect(() => {
    const sessionData = JSON.parse(sessionStorage.getItem("bookingDetails"));
    console.log("sessionData", sessionData);
    setSessionData(JSON.parse(sessionStorage.getItem("bookingDetails")));
  }, []);

  // get all room name and price

  useEffect(() => {
    fetch(
      // "https://api.bgmhotel.com/roomName"
      "https://api.bgmhotel.com/roomName"
    )
      .then((response) => response.json())
      .then((json) => {
        setRoomName(json);
      })
      .catch((error) => {
        console.error("Error fetching rooms:", error);
      });
  }, []);

  const [price, setPrice] = useState(null);
  const handleNameChange = (event) => {
    // const id = event.target.value; // Get the selected ID

    fetch(`https://api.bgmhotel.com/roomName/${event?.target?.value}`)
      .then((response) => response.json())
      .then((json) => {
        setPrice(json);
      });
  };
  return (
    <>
      {/* <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="http://bgmhotel.com/booking" />
        <link rel="canonical" href="https://www.bgmhotel.com/booking" />
        <link rel="canonical" href="https://bgmhotel.com/booking" />
      </Helmet> */}
      {}
      {isBookingForm ? (
        <Heading
          heading="Book Your Room"
          title="Home"
          subtitle="Book Your Room"
        />
      ) : (
        // "booking page"
        "contact page"
      )}

      {/* {isBookingForm ? (
        <div className="banner">
          <div
            className="col-12 bg-dark text-white jumbotron"
            style={{ height: "25rem", top: "50%" }}
          >
           
            <div className=" text-center overflow-hidden text-overlay">
              <div className="text-style">
                <h6 className="section-title text-white text-uppercase mb-3 animated slideInDown">
                  With The Best Prices
                </h6>
                <h3 className="display-3 text-white mb-4 animated slideInDown">
                  <span>Book Your Rooms</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )} */}

      <div className="room-details container">
        {roomData ? (
          <>
            <h3>{roomData.roomType}</h3>
            <div className="col-12 pb-3 ">
              <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12 imgthumb">
                  <div className="row">
                    <div
                      className="thumbnail-container col-3"
                      data-aos="flip-right"
                      data-aos-offset="100"
                    >
                      {roomData.thumbnail.map((thumbSrc, index) => (
                        <img
                          key={index}
                          src={`https://api.bgmhotel.com${thumbSrc.url}`}
                          alt={`Thumbnail ${index + 1}`}
                          onClick={() => setMainImage(thumbSrc)}
                          style={{
                            width: "100%",
                            height: "80px",
                            marginBottom: "10px",
                            cursor: "pointer",
                            objectFit: "cover",
                            border: "",
                          }}
                        />
                      ))}
                    </div>

                    <div
                      className="main-image col-9"
                      data-aos="flip-up"
                      data-aos-offset="100"
                    >
                      <img
                        // src={mainImage}
                        src={`https://api.bgmhotel.com${mainImage?.url}`}
                        alt="Room"
                        style={{
                          width: "100%",
                          height: "97%",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 ratefaci pb-2">
                  <h5>
                    {iconMapping[roomData.price.icon] ? (
                      React.createElement(iconMapping[roomData.price.icon], {
                        size: 24,
                      })
                    ) : (
                      <span>{roomData.price.icon}</span>
                    )}
                    {roomData.price.label} / Night
                  </h5>
                  <div className="row pb-4">
                    {roomData.facilities.map((facility, indexFaci) => (
                      <div
                        className="col-lg-6 col-md-3 col-sm-4 col-xs-6 d-flex align-items-center pt-2"
                        key={indexFaci}
                        style={{ textWrap: "nowrap" }}
                      >
                        <div className="me-2">
                          {iconMapping[facility.icon] ? (
                            React.createElement(iconMapping[facility.icon], {})
                          ) : (
                            <>{facility.icon} </>
                          )}
                        </div>
                        &nbsp;
                        <span> {facility.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* booking form start */}
            <p>
              Each booking comes with access to our world-class amenities,
              including high-speed WiFi, luxurious bedding, and breathtaking
              views of Your Location. Need something extra? Our team is happy to
              customize your stay with special requests, from arranging early
              check-ins to adding thoughtful touches that make your visit truly
              unforgettable.
            </p>
            <p>
              Don't wait to create memories that last a lifetime. Reserve your
              room today and let us welcome you with exceptional service,
              culinary delights, and the warm hospitality that BGM Hotel &
              Restaurant is known for. Your next adventure starts here!
            </p>
            <div
              className="col-12 p-4 mb-5 card"
              // style={{ color: "#20202085" }}
            >
              {/* start for form */}
              <h6 style={{ background: "" }} className="btn-dark-custom p-3">
                You are booking as guest.
              </h6>
              <h3>Add Your Information:</h3>
              <form className="row g-3" onSubmit={sendInquiry}>
                <div className="col-md-6">
                  <label htmlFor="roomType" className="form-label">
                    Room Type
                  </label>
                  <input
                    name="roomType"
                    type="text"
                    className="form-control"
                    required
                    readOnly
                    value={roomData.roomType}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="price" className="form-label">
                    Price / Night <sup>* GST Extra on total</sup>
                  </label>
                  <input
                    type="text"
                    value={roomData.price.label}
                    className="form-control"
                    required
                    readOnly
                    name="price"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="inputPhone" className="form-label">
                    Name
                  </label>
                  <input
                    type="consumerName"
                    name="consumerName"
                    className="form-control"
                    id="inputPhone"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="inputPhone" className="form-label">
                    Phone Number
                  </label>
                  <input
                    required
                    name="phoneNumber"
                    type="text"
                    className="form-control"
                    placeholder="Contact Number"
                    aria-label="Contact Number"
                    aria-describedby="btnGroupAddon2"
                    maxLength="10"
                    pattern="\d{10}"
                    onInput={(e) =>
                      (e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 10))
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="inputPhone" className="form-label">
                    Alternate Number
                  </label>
                  <input
                    name="alterNumber"
                    type="text"
                    className="form-control"
                    placeholder="Contact Number"
                    aria-label="Contact Number"
                    aria-describedby="btnGroupAddon2"
                    maxLength="10"
                    pattern="\d{10}"
                    onInput={(e) =>
                      (e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 10))
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="inputEmail" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="inputEmail"
                    required
                    name="email"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">CHECK IN</label>
                  <input
                    name="checkIn"
                    className="form-control"
                    type="date"
                    min={new Date().toISOString().split("T")[0]} // Disable past dates
                    // value={checkInDate}
                    value={sessionData ? sessionData.chaekIn : checkInDate}
                    onChange={(e) => {
                      setCheckInDate(e.target.value);
                      calculateDateDifference(e.target.value, checkOutDate);
                    }}
                  />
                </div>

                {/* Check-Out Date */}
                <div className="col-md-6">
                  <label className="form-label">CHECK OUT</label>
                  <input
                    name="checkOut"
                    className="form-control"
                    type="date"
                    min={checkInDate || new Date().toISOString().split("T")[0]} // Disable dates before check-in
                    // value={checkOutDate}
                    value={sessionData ? sessionData.chaekOut : checkOutDate}
                    onChange={(e) => {
                      setCheckOutDate(e.target.value);
                      calculateDateDifference(checkInDate, e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="state" className="form-label">
                    State
                  </label>

                  <input
                    class="form-control"
                    name="state"
                    list="state"
                    id=""
                    placeholder="Select State"
                    value={selectedState}
                    onChange={handleStateChange}
                  />
                  <datalist id="state">
                    <option value="">Select State</option>
                    {states.map((state, index) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </datalist>
                  {/* <select
                    name="state"
                    id="state"
                    className="form-control"
                    required
                    value={selectedState}
                    onChange={handleStateChange}
                  >
                    <option value="">Select State</option>
                    {states.map((state, index) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </select> */}
                </div>
                <div className="col-md-6">
                  <label htmlFor="city" className="form-label">
                    City
                  </label>
                  <input
                    class="form-control"
                    name="city"
                    list="city"
                    id=""
                    placeholder="Select City"
                  />
                  <datalist id="city">
                    <option value="">Select City</option>
                    {cities.map((city, index) => (
                      <option key={index} value={city}>
                        {city}
                      </option>
                    ))}
                  </datalist>
                  {/* <select
                    id="city"
                    className="form-control"
                    required
                    name="city"
                  >
                    <option value="">Select City</option>
                    {cities.map((city, index) => (
                      <option key={index} value={city}>
                        {city}
                      </option>
                    ))}
                  </select> */}
                </div>
                <div className="col-md-12">
                  <label htmlFor="inputAddress" className="form-label">
                    Address
                  </label>
                  <textarea
                    className="form-control"
                    id="inputAddress"
                    rows="3"
                    required
                    name="address"
                  />
                </div>
                <div className="col-lg-3 col-sm-12 col-xs-12">
                  <button
                    type="submit"
                    className="btn btn-primary-custom animated slideInLeft col-md-12 col-sm-12 col-xs-12"
                    disabled={isPending}
                  >
                    BOOK NOW
                  </button>
                </div>
              </form>
            </div>
          </>
        ) : (
          <>
            <Contact />
          </>
        )}
      </div>
      <SampleRoom />
    </>
  );
};

export default RoomBooking;
